import { getStatsTransformStrategy } from '../strategies/transform';

// gets stats into consistent format (total) before averaging
export const normaliseStat = (aggregation: string, groupBy: string, paramValue: number, multiplier: number): number => {
    const strat = getStatsTransformStrategy(aggregation);
    return strat.applyNormalisation(paramValue, multiplier, groupBy);
};
